export default __webpack_public_path__ + "static/media/cabimer.c8b66f2b.png";